import { sortBy } from 'lodash/collection'
import { apiClient } from '@/client'

const state = {
  isLoading: false,
  networks: []
}

const getters = {
  networks: state => sortBy(state.networks, ['description'])
}
const mutations = {
  SET_LOADING: (state, payload) => {
    state.isLoading = payload
  },
  SET_NETWORKS: (state, payload) => {
    state.networks = payload
  }
}

const actions = {
  fetchNetworks: ({ commit }) => {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      apiClient
        .getAllNetworks()
        .then(payload => {
          commit('SET_LOADING', false)
          let result = payload.map(network => ({
            ...network,
            nodes: sortBy(network.nodes, ['description'])
          }))
          commit('SET_NETWORKS', result)
          resolve(true)
        })
        .catch(e => {
          commit('SET_LOADING', false)
          reject(e)
        })
    })
  },
  addNode: ({ dispatch }, node) => {
    return new Promise((resolve, reject) => {
      apiClient
        .addNode(node)
        .then(() => {
          dispatch('fetchNetworks').then(resolve)
        })
        .catch(reject)
    })
  },
  addNetwork: ({ dispatch }, network) => {
    return new Promise((resolve, reject) => {
      apiClient
        .addNetwork(network)
        .then(() => {
          dispatch('fetchNetworks').then(resolve)
        })
        .catch(reject)
    })
  },
  deleteNetwork: ({ dispatch }, network) => {
    return new Promise((resolve, reject) => {
      apiClient
        .deleteNetwork(network)
        .then(() => {
          dispatch('fetchNetworks').then(resolve)
        })
        .catch(reject)
    })
  },
  deleteNode: ({ dispatch }, { node, network }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .deleteNode(node, network)
        .then(() => {
          dispatch('fetchNetworks').then(resolve)
        })
        .catch(reject)
    })
  }
}

export default { state, getters, mutations, actions }
